<template>
    <div class="row">
        <div class="col-xl-12">
            <div class="panel">
                <div class="customer-page p-3">
                    <div class="d-flex justify-content-end align-items-center mb-3">
                        <el-button size="small" @click="exportExcel()"  type="primary"> <i class="el-icon-download mr-1"></i> Export</el-button>
                    </div>

                    <el-row :gutter="10" class="filter-section mt-3" >
                        <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5">
                            <el-select v-if="[7,6].includes(keyAccount) || [295391, 266029].includes(currentUser.id)" @change="queryServer(); getCenter()" v-model="form.area_id" placeholder="Chọn Khu vực" filterable  collapse-tags clearable class="w-100 mt-2">
                                <el-option v-for="item in areas" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5" v-if="[5,6,7].includes(keyAccount) || [295391, 266029].includes(currentUser.id) || currentUser.profile.account_type_id === 18">
                            <el-select @change="queryServer(); getChildUser(form.branch_id)" v-model="form.branch_id" placeholder="Chọn văn phòng" filterable clearable class="w-100 mt-2">
                                <el-option v-for="item in branches" :key="item.id" :label="item.name_alias || item.name" :value="item.id" />
                            </el-select>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5">
                            <tree-select v-model="cache_sale" :normalizer=normalizer
                                         :options="options"
                                         :show-count="true" class="w-100 mt-2"
                                         placeholder="Chọn nhân sự muốn xem..."
                                         search-nested
                                         @input="handleChangeSale" >
                                <!--eslint-disable-->
                                <label slot="option-label"
                                       slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }"
                                       :class="labelClassName">
                                    <img :src="publicPath + getImageHierarchy(node.raw.profile.account_type.id)" alt="">
                                    <span> {{ node.label }} -  {{node.raw.id + 100000}}</span>
                                    <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
                                </label>
                            </tree-select>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5" v-if="form.sale">
                            <el-select v-model="form.view_as" @change="queryServer();" clearable class="w-100 mt-2"
                                       placeholder="Chọn tư cách để xem">
                                <el-option v-for="item in watchAs" :key="item.id" :label="item.value"
                                           :value="item.id"/>
                            </el-select>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5">
                            <el-select @change="queryServer" v-model="form.goal_type" placeholder="Chọn loại mục tiêu" clearable class="w-100 mt-2">
                                <el-option v-for="item in typeGoal" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5">
                            <el-select @change="queryServer" v-model="form.account_type_id" placeholder="Chọn chức vụ" clearable class="w-100 mt-2">
                                <el-option v-for="item in filteredPositions" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5">
                            <el-date-picker @change="queryServer"
                                            v-model="form.dateRange"
                                            type="daterange"
                                            value-format="yyyy-MM-dd"
                                            clearable
                                            start-placeholder="Từ ngày"
                                            end-placeholder="Đến ngày"
                                            class="w-100 mt-2" />
                        </el-col>
                    </el-row>

                    <!-- Table -->
                    <el-table
                        :data="tableData"
                        :height="tableHeight"
                        class="mt-4"
                        :show-summary="true"
                        sum-text="Tổng mục tiêu"
                        :summary-method="getSummaries"
                    >
                        <el-table-column label="STT" type="index" />
                        <el-table-column label="Văn phòng" min-width="80">
                            <template v-slot="scope">
                                <span>{{ scope.row?.branch?.name_alias || scope.row?.branch?.name }} </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="Khu vực" min-width="50">
                            <template v-slot="scope">
                                <span>{{ scope.row?.area?.name ?? '' }} </span>
                            </template>
                        </el-table-column>

                        <el-table-column label="Nhân sự" min-width="90">
                            <template v-slot="scope">
                                <span>{{ scope.row?.user?.name ?? '' }} </span>
                            </template>
                        </el-table-column>

                        <el-table-column label="Mã nhân sự" min-width="50">
                            <template v-slot="scope">
                                <span>{{ scope.row?.user?.id + 100000 ?? '' }} </span>
                            </template>
                        </el-table-column>

                        <el-table-column label="Loại mục tiêu" min-width="120">
                            <template v-slot="scope">
                                <span>{{ goalTypeDefine[scope.row?.goal_type] + '  ' +  handleDateGoal(scope.row)}} </span>
                            </template>
                        </el-table-column>

                        <el-table-column label="Số hợp đồng/mục tiêu" >
                            <template v-slot="scope">
                                <el-tooltip
                                    effect="dark"
                                    :content="getSuccessRate(scope.row.contract_new, scope.row.target_contract_new)"
                                    placement="top">
                                  <span>
                                    <span :class="scope.row.contract_new >= scope.row.target_contract_new ? 'text-success' : 'text-danger'">
                                      {{ scope.row.contract_new?.toLocaleString('vi-VN') ?? 0 }}
                                    </span>
                                    /
                                    <span>{{ scope.row.target_contract_new?.toLocaleString('vi-VN') ?? 0 }}</span>
                                  </span>
                                </el-tooltip>
                            </template>
                        </el-table-column>

                        <el-table-column label="Số lịch hẹn/mục tiêu" >
                            <template v-slot="scope">
                                <el-tooltip
                                    effect="dark"
                                    :content="getSuccessRate(scope.row.customer_2A, scope.row.target_customer_2A)"
                                    placement="top">
                                  <span>
                                    <span :class="scope.row.customer_2A >= scope.row.target_customer_2A ? 'text-success' : 'text-danger'">
                                      {{ scope.row.customer_2A?.toLocaleString('vi-VN') ?? 0 }}
                                    </span>
                                    /
                                    <span>{{ scope.row.target_customer_2A?.toLocaleString('vi-VN') ?? 0 }}</span>
                                  </span>
                                </el-tooltip>
                            </template>
                        </el-table-column>

                        <el-table-column label="Số lịch tư vấn/mục tiêu">
                            <template v-slot="scope">
                                <el-tooltip
                                    effect="dark"
                                    :content="getSuccessRate(scope.row.schedule_number, scope.row.target_schedule_number)"
                                    placement="top">
                                  <span>
                                    <span :class="scope.row.schedule_number >= scope.row.target_schedule_number ? 'text-success' : 'text-danger'">
                                      {{ scope.row.schedule_number?.toLocaleString('vi-VN') ?? 0 }}
                                    </span>
                                    /
                                    <span>{{ scope.row.target_schedule_number?.toLocaleString('vi-VN') ?? 0 }}</span>
                                  </span>
                                </el-tooltip>
                            </template>
                        </el-table-column>

                        <el-table-column label="Doanh số/mục tiêu">
                            <template v-slot="scope">
                                <el-tooltip
                                    effect="dark"
                                    :content="getSuccessRate(scope.row.goal_amount, scope.row.target_amount)"
                                    :disabled="!scope.row.target_amount"
                                    placement="top">
                                  <span>
                                    <span :class="getRateClass(scope.row.goal_amount, scope.row.target_amount)">
                                      {{ (scope.row.goal_amount ?? 0).toLocaleString('vi-VN') }}
                                    </span>
                                    /
                                    <span>{{ (scope.row.target_amount ?? 0).toLocaleString('vi-VN') }}</span>
                                  </span>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>

                    <el-pagination
                        class="mt-3 text-center"
                        background
                        @current-change="handleCurrentChange"
                        :current-page="paging.current_page"
                        :page-size="paging.per_page"
                        layout="prev, pager, next"
                        :total="paging.total">
                    </el-pagination>
                    <el-dialog title="Chỉnh sửa bộ lọc" :visible.sync="dialogFilterVisible" width="600px">
                        <p>Nội dung filter search...</p>
                    </el-dialog>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {BRANCH_LIST} from "@/core/services/store/service.module";
import {GET_REGIONS_BY_USER} from "@/core/services/store/customer/customer.module";
import {mapGetters, mapState} from "vuex";
import {GET_SALE_GOAL_LIST } from "@/core/services/store/report.module";
import {GET_CHILD_USER} from "@/core/services/store/service.module";

export default {
    name: 'sales-input',
    data() {
        return {
            publicPath: process.env.VUE_APP_BASE_URL,
            dialogFilterVisible: false,
            form: {
                branch_id: '',
                area_id: '',
                date: this.$moment(),
                goal_type: '',
                dateRange: [],
                sale: '',
                export: 0,
                view_as: '',
                account_type_id: '',
            },
            tableData: [],
            branches: [],
            areas: [],
            options: [],
            childUsers: [],
            paging: {
                total: 0,
                per_page: 25,
                current_page: 1,
            },
            is_staff: false,
            tableHeight: 520,
            imageHierarchy: {
                '5': 'media/hierarchy/gdvp.png',
                '1': 'media/hierarchy/sl.png',
                '2': 'media/hierarchy/se.png',
                '3': 'media/hierarchy/s.png',
                '4': 'media/hierarchy/si.png'
            },

            typeGoal: [
                {id: 0, name:'Mục tiêu ngày'},
                {id: 1, name:'Mục tiêu tuần'},
                {id: 2, name:'Mục tiêu tháng'}
            ],

            goalTypeDefine: {
                '0': 'Mục tiêu Ngày',
                '1': 'Mục tiêu Tuần',
                '2': 'Mục tiêu Tháng',
            },
            watchAs: [
                {
                    id: 1,
                    value: 'Đội kinh doanh',
                    label: 'Đội'
                },
                {
                    id: 2,
                    value: 'Cá nhân',
                    label: 'Cá nhân'
                }
            ],

            positions: [
                {id: 1, name: 'Sales Leader'},
                {id: 2, name: 'Sales Expert'},
                {id: 3, name: 'Sales'},
                {id: 4, name: 'Sales Intern'},
                {id: 5, name: 'Giám đốc văn phòng'},
                {id: 6, name: 'Giám đốc khu vực'},
                {id: 26, name: 'Giám đốc vùng'},
            ],

            keyAccountMap: {
                7: [26, 6, 5, 1, 2, 3, 4], // BOD
                6: [6, 5, 1, 2, 3, 4, 26], // Giám đốc vùng
                5: [5, 1, 2, 3, 4, 6], // Giám đốc khu vực
                4: [1, 2, 3, 4, 5], // Giám đốc văn phòng
                3: [1,2, 3, 4], //Sales Leader
            },

            cache_sale: null,
            currentPage: 1,
        };
    },

    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            {title: "Tiến độ đạt mục tiêu", icon: 'far fa-money-bill'}
        ]);

        this.setDefaultDateRange();
        this.getCenter();
        this.getRegions();
        this.queryServer();
        this.form.date = new Date();
        this.getChildUser();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calcTableHeight);
    },
    methods: {
        calcTableHeight() {
            this.$nextTick(() => {
                const filter = this.$el.querySelector('.filter-section');
                const bottom = filter ? filter.getBoundingClientRect().bottom : 0;
                const available = window.innerHeight - bottom - 160;
                this.tableHeight = Math.max(320, available);
            });
        },
        getChildUser() {
            var branchId = '';
            if([1,5].includes(this.currentUser.account_type.id)){
                branchId = this.currentUser.profile.chi_nhanh_id;
            };
            const payload = {
                branch_id: this.form.branch_id || branchId,
            };
            this.$store.dispatch(GET_CHILD_USER, payload)
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({type: 'warning', message: `${response.message}`, showClose: true});
                    } else {
                        this.childUsers = response.data;
                        this.options = response.data;
                    }
                });
        },

        queryServer() {
            const payload = {
                date_range : this.form.dateRange ?? [],
                user_id: this.form.user_id,
                goal_type: this.form.goal_type,
                area_id: this.form.area_id,
                branch_id: this.form.branch_id,
                export : this.form.export,
                view_as : this.form.view_as,
                sale : this.form.sale,
                account_type_id : this.form.account_type_id,
                page       : this.paging.current_page,
                per_page   : this.paging.per_page,
            }

            this.$store.dispatch(GET_SALE_GOAL_LIST, payload).then((res) => {
                if (res) {
                    this.tableData = res.data.data;
                    this.paging.current_page = res.data.current_page;
                    this.paging.per_page    = res.data.per_page;
                    this.paging.total       = res.data.total;
                }
            });
        },

        getCenter() {
            const payload = {
                area_id: this.form.area_id
            };

            this.$store.dispatch(BRANCH_LIST,payload)
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({type: 'warning', message: `${response.message}`, showClose: true});
                    } else {
                        this.branches = response.data;
                    }
                })

        },

        getRegions() {
            const payload = {
                all: this.keyAccount === 7 ? 1 : 0
            };
            this.$store.dispatch(GET_REGIONS_BY_USER, payload)
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({type: 'warning', message: `${response.message}`, showClose: true});
                    } else {
                        this.areas = response.data;
                    }
                })
        },

        handleChangeSale() {
            this.form.sale = this.cache_sale;
            if(!this.form.sale) {
                this.form.view_as = '';
            }
            this.queryServer();
        },

        normalizer: function (node) {
            return {
                id: node.id,
                label: node.name,
            }
        },

        getImageHierarchy(account_type) {
            return this.imageHierarchy[account_type];
        },

        handleDateGoal(item) {
            switch(item.goal_type) {
                case 0:
                    return `${item.date}/${item.month}/${item.year}`;
                case 1:
                    const year = item.year;
                    const week = item.week;

                    // Tính ngày thứ hai đầu tiên của năm
                    const firstDayOfYear = new Date(year, 0, 1); // 01/01/yyyy
                    const firstMonday = new Date(firstDayOfYear);
                    const dayOffset = (firstDayOfYear.getDay() + 6) % 7; // đưa về thứ 2
                    firstMonday.setDate(firstDayOfYear.getDate() - dayOffset);

                    const startOfWeek = new Date(firstMonday);
                    startOfWeek.setDate(startOfWeek.getDate() + (week - 1) * 7);

                    const endOfWeek = new Date(startOfWeek);
                    endOfWeek.setDate(endOfWeek.getDate() + 6);

                    const formatShort = (date) => {
                        const d = date.getDate().toString().padStart(2, '0');
                        const m = (date.getMonth() + 1).toString().padStart(2, '0');
                        return `${d}/${m}`;
                    };
                    return `${formatShort(startOfWeek)} - ${formatShort(endOfWeek)}/${year}`;
                case 2:
                    return `${item.month}/${item.year}`;
                default:
                    return '';
            }
        },

        handleCurrentChange(page) {
            this.paging.current_page = page;
            this.queryServer()
        },

        exportExcel() {
            this.form.export = 1;
            const url = this.getExportUrl();
            window.open(url, '_blank');
            this.form.export = 0;

        },

        getExportUrl() {
            const params = {
                date_range : this.form.dateRange ?? [],
                user_id: this.form.user_id,
                goal_type: this.form.goal_type,
                export : this.form.export,
                sale : this.form.sale,
                page       : this.paging.current_page,
                per_page   : this.paging.per_page,
            };
            const parts = [];
            Object.entries(params).forEach(([key, value]) => {
                if (Array.isArray(value)) {
                    value.forEach(val => {
                        parts.push(`${encodeURIComponent(key)}[]=${encodeURIComponent(val)}`);
                    });
                } else {
                    parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value ?? '')}`);
                }
            });
            const queryString = parts.join('&');
            return `${process.env.VUE_APP_API_URL}/goal/get-list-goal-by-sale?${queryString}`;
        },

        setDefaultDateRange() {
            const today = new Date();
            const year = today.getFullYear();
            const monthIndex = today.getMonth();
            const mm = String(monthIndex + 1).padStart(2, '0');
            const startOfMonth = `${year}-${mm}-01`;
            const lastDay = new Date(year, monthIndex + 1, 0).getDate();
            const endOfMonth = `${year}-${mm}-${String(lastDay).padStart(2, '0')}`;
            this.form.dateRange = [startOfMonth, endOfMonth];
        },

        getSuccessRate(dial, denominator) {
            if (!dial || !denominator) return "0%";
            const percent = (dial / denominator) * 100;
            return `${parseFloat(percent.toFixed(2))}%`;
        },
        getRateClass(current, target) {
            return Number(current) >= Number(target) ? 'text-success' : 'text-danger';
        },

        getSummaries({ columns, data }) {
            const sums = Array(columns.length).fill('');
            sums[0,3] = 'Tổng mục tiêu';

            columns.forEach((col, idx) => {
                switch (col.label) {
                    case 'Số hợp đồng/mục tiêu': {
                        const a = this.total(data, 'contract_new');
                        const b = this.total(data, 'target_contract_new');
                        sums[idx] = `${this.fmt(a)} / ${this.fmt(b)}`;
                        break;
                    }
                    case 'Số lịch hẹn/mục tiêu': {
                        const a = this.total(data, 'customer_2A');
                        const b = this.total(data, 'target_customer_2A');
                        sums[idx] = `${this.fmt(a)} / ${this.fmt(b)}`;
                        break;
                    }
                    case 'Số lịch tư vấn/mục tiêu': {
                        const a = this.total(data, 'schedule_number');
                        const b = this.total(data, 'target_schedule_number');
                        sums[idx] = `${this.fmt(a)} / ${this.fmt(b)}`;
                        break;
                    }
                    case 'Doanh số/mục tiêu': {
                        const a = this.total(data, 'goal_amount');
                        const b = this.total(data, 'target_amount');
                        sums[idx] = `${this.fmt(a)} / ${this.fmt(b)}`;
                        break;
                    }
                    default:
                        break;
                }
            });

            return sums;
        },
        n(v) { return Number(v) || 0; },
        fmt(v) { return this.n(v).toLocaleString('vi-VN'); },

        total(data, field) {
            return data.reduce((acc, row) => acc + this.n(row[field]), 0);
        },
    },
    computed: {
        ...mapState({
            errors: (state) => state.auth.errors,
        }),
        ...mapGetters(["currentUser", "keyAccount"]),

        filteredPositions() {
            if (!this.keyAccount) return this.positions;
            const ids = this.keyAccountMap[this.keyAccount] || [];
            return this.positions.filter(p => ids.includes(p.id));
        }
    },
};
</script>

<style>
#sales-input .tree-customer .vue-treeselect__option,
#sales-input .vue-treeselect__control,
#sales-input input.el-input__inner {
    background: rgb(237 237 237)
}

.tree-customer .vue-treeselect__control .vue-treeselect__placeholder,
#sales-input .tree-customer .vue-treeselect__option,
#sales-input .el-input .el-input__inner::placeholder,
#sales-input .el-select .el-input__inner::placeholder {
    font-family: SVN-Gilroy;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0px;
    vertical-align: middle;
    color: rgba(6, 7, 11, 0.6);
}

.text-sales {
    font-family: SVN-Gilroy;
    font-weight: 700;
    font-size: 16px;
    line-height: 31px;
    letter-spacing: 0px;
    vertical-align: middle;
}

.dialogSetting .el-dialog__body {
    padding: 2px 20px;
}

</style>
